class CultureSelection {
    constructor() {
        jQuery(() => {
            CultureSelection.prototype.initializeCultureSelection();
        });
    }

    private initializeCultureSelection() {
        const select = document.getElementById("culture") as HTMLSelectElement;
        if (select) {
            // auto submit on change
            select.onchange = function(e) {
                const form: HTMLFormElement = (this as any).form;
                const refererInput: HTMLInputElement = document.createElement("input");
                refererInput.type = "hidden";
                refererInput.name = "returnUrl";
                refererInput.value = window.location.href;
                form.appendChild(refererInput);
                form.submit();
            };
        }
    }
}

// needed on all pages
if (/\/?$/i.test(location.pathname)) {
    const cultureSelectionWindow = window as any;
    cultureSelectionWindow.cultureSelection = new CultureSelection();
}
